import * as React from 'react';
export const thumbsDownSvg = React.forwardRef(function thumbsDownSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4 9.671V8H2a2 2 0 0 1-2-2v-.366a1 1 0 0 1 .035-.263l1.063-3.897A2 2 0 0 1 3.028 0H10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H8.929l-1.107 3.874c-.19.666-.8 1.126-1.493 1.126A2.329 2.329 0 0 1 4 9.671Zm3.6-3.117-1.124 3.935a.153.153 0 0 1-.147.111.929.929 0 0 1-.929-.929V8A1.4 1.4 0 0 0 4 6.6H2a.6.6 0 0 1-.6-.6v-.313l1.049-3.845a.6.6 0 0 1 .579-.442H7.6v5.154ZM9 5.6h1a.6.6 0 0 0 .6-.6V2a.6.6 0 0 0-.6-.6H9v4.2Z',
    }),
  );
});
thumbsDownSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var thumbsDown = {
  category: 'icon',
  colorable: true,
  name: 'thumbsDown',
  svg: thumbsDownSvg,
};
